var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",attrs:{"id":"Error401UnauthorizedView"}},[_c('h1',[_vm._v(_vm._s(this.$i18n.t('views.errors.error401UnauthorizedView.title')))])])}
var staticRenderFns = []

export { render, staticRenderFns }